/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    DASHBOARD_PROFILE_BOXES
 * Date:         2025-12-27
 * Modified By:  Cursor
 *
 * Description:
 * Added DashboardProfileBoxes component between search banner and broadcasts list.
 *
 * Related Screens / Modules:
 * - client/src/features/dashboard/DashboardProfileBoxes.tsx
 * - client/src/pages/Dashboard.tsx
 */

import React from "react";
import DashboardSearchBanner from "../features/dashboard/DashboardSearchBanner";
import DashboardProfileBoxes from "../features/dashboard/DashboardProfileBoxes";
import DashboardBroadcastList from "../features/dashboard/DashboardBroadcastList";

// [2025-12-27] Dashboard: Add profile boxes between banner and broadcasts
const Dashboard: React.FC = () => {
  // [2026-07-06] GUEST_ACCESS BR-09/10: guests now see the full dashboard, but the profile
  // boxes render as N/A with locked buttons, and the broadcasts feed uses the masked /public
  // endpoint (no My Broadcasts, View All locked). Both components handle guest mode internally.
  return (
    // [2026-02-06] Removed container class - padding handled by individual components
    // [2026-02-07] style-extraction: moved inline style to _profile-boxes.scss
    <main className="mb-5 dashboard-main">
      <DashboardSearchBanner />
      <DashboardProfileBoxes />
      <DashboardBroadcastList />
    </main>
  );
};

export default Dashboard;
